export * from './confirm.component';
